export * from './confirm.component';
